export function keypressEnterOrSpace(fn) {
  return function enterSpaceHandler(event) {
    if (event.which === 13 || event.which === 32) {
      fn(event);
    }
  };
}